// Public service-layer API — all functions are async, all data comes
// from the FastAPI backend (`REACT_APP_BACKEND_URL`).
//
// Every function accepts an optional `{ signal }` for AbortController
// integration — used by hooks to cancel in-flight requests on unmount /
// StrictMode double-invoke, keeping the devtools console clean.

import {
  httpListOpportunities,
  httpGetFeaturedOpportunity,
  httpGetOpportunityById,
  httpListCountries,
  httpListIndustries,
  httpListOpportunityTypes,
  httpBootstrap,
} from "./httpAdapter";

/* ─── Opportunities ────────────────────────────────────────────────── */

export const listOpportunities        = (opts) => httpListOpportunities(opts);
export const getFeaturedOpportunity   = (opts) => httpGetFeaturedOpportunity(opts);
export const getOpportunityById       = (id, opts) => httpGetOpportunityById(id, opts);

/* ─── Reference data ───────────────────────────────────────────────── */

export const listCountries            = (opts) => httpListCountries(opts);
export const listIndustries           = (opts) => httpListIndustries(opts);
export const listOpportunityTypes     = (opts) => httpListOpportunityTypes(opts);

/* ─── Bootstrap (single-shot Home + List loader) ───────────────────── */

export const bootstrap                = (opts) => httpBootstrap(opts);
